import { render, staticRenderFns } from "./PlaybookEventsFeed.vue?vue&type=template&id=380cbd11&scoped=true&"
import script from "./PlaybookEventsFeed.vue?vue&type=script&lang=js&"
export * from "./PlaybookEventsFeed.vue?vue&type=script&lang=js&"
import style0 from "./PlaybookEventsFeed.vue?vue&type=style&index=0&id=380cbd11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cbd11",
  null
  
)

export default component.exports